import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(customerCardStyles, {
    selectButton: {
        css: css`
            width: 135px;
            position: inherit;
            left: inherit;
            bottom: inherit;
            text-transform: uppercase;
            border-radius: 22px;
            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
            border: none;
            color: ${COLORS.white};
            & :hover {
                background: ${COLORS.secondaryBtn};
            }
            &:disabled {
                background: ${COLORS.disabled.base};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
            }
        `,
        typographyProps: {
            css: css`
                font-size: 15px;
                font-weight: 600;
            `,
        },
    },
});
